/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as PreviewDataGrid } from './preview-data-grid.story';
export { default as PreviewConfirmationStandalone } from './preview-confirmation-standalone.story';
export { default as PreviewCodeConfirmation } from './preview-code-confirmation.story';
export { default as PreviewCodeLoading } from './preview-code-loading.story';
export { default as PreviewCodeRead } from './preview-code-read.story';
export { default as PreviewCodeWrite } from './preview-code-write.story';
export { default as PreviewCodeLanguages } from './preview-code-languages.story';

import { removeLicenseHeader } from '../../../_common/export-stories-utils';
import PreviewCodeConfirmationSrcRaw from './preview-code-confirmation.story?raw';
import PreviewCodeLanguagesSrcRaw from './preview-code-languages.story?raw';
import PreviewCodeLoadingSrcRaw from './preview-code-loading.story?raw';
import PreviewCodeReadSrcRaw from './preview-code-read.story?raw';
import PreviewCodeWriteSrcRaw from './preview-code-write.story?raw';
import PreviewConfirmationStandaloneSrcRaw from './preview-confirmation-standalone.story?raw';
import PreviewDataGridSrcRaw from './preview-data-grid.story?raw';

export const PreviewDataGridSrc = removeLicenseHeader(PreviewDataGridSrcRaw);
export const PreviewConfirmationStandaloneSrc = removeLicenseHeader(
  PreviewConfirmationStandaloneSrcRaw,
);
export const PreviewCodeConfirmationSrc = removeLicenseHeader(
  PreviewCodeConfirmationSrcRaw,
);
export const PreviewCodeLoadingSrc = removeLicenseHeader(
  PreviewCodeLoadingSrcRaw,
);
export const PreviewCodeReadSrc = removeLicenseHeader(PreviewCodeReadSrcRaw);
export const PreviewCodeWriteSrc = removeLicenseHeader(PreviewCodeWriteSrcRaw);
export const PreviewCodeLanguagesSrc = removeLicenseHeader(
  PreviewCodeLanguagesSrcRaw,
);
